const CompanyTypes = {
    PURCHASE_ACTION_START:"PURCHASE_ACTION_START",
    PURCHASE_FETCH_DATA:"PURCHASE_FETCH_DATA",
    PURCHASE_FETCH_DATA_FAILED:"PURCHASE_FETCH_DATA_FAILED",
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
}

const PurchaseReducer = (state=Initial_state, action) => {
    switch(action.type){
        case CompanyTypes.PURCHASE_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case CompanyTypes.PURCHASE_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload,
            }

        case CompanyTypes.PURCHASE_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }
        default:
            return state;
    }
};

export default PurchaseReducer;